module.exports = __webpack_public_path__ + "img/produto-semimagem.4dad9376.jpg";